import { Typography } from "@mui/material";
import { PhaseListForms } from "./types";
import React from "react";
import { useTranslation } from "react-i18next";

const LockStatus = ({
  selectedForm,
}: {
  selectedForm: PhaseListForms | null;
}) => {
  const { t } = useTranslation("responses");

  if (
    !selectedForm?.isSigned &&
    !selectedForm?.locked &&
    !selectedForm?.isSubmitted
  ) {
    return null;
  }

  const lockedBy = selectedForm?.lockedBy?.trim() || "";
  const isManualLock = !!lockedBy;

  const isSame =
    selectedForm?.lockedAt === selectedForm?.signedAt &&
    selectedForm?.signedBy === selectedForm?.lockedBy &&
    isManualLock;

  return (
    <>
      {selectedForm?.isSubmitted && (
        <Typography variant="body1" color="text.secondary">
          {t("SUBMITTED_STATUS", {
            time: selectedForm?.submittedAt || "",
          })}
        </Typography>
      )}
      {isSame ? (
        <Typography variant="body1" color="text.secondary">
          {t("LOCK_STATUS_SIGNED_LOCKED", {
            name: selectedForm?.signedBy,
            time: selectedForm?.signedAt,
          })}
        </Typography>
      ) : (
        <>
          {selectedForm?.isSigned && (
            <Typography variant="body1" color="text.secondary">
              {t("LOCK_STATUS_SIGNED", {
                name: selectedForm?.signedBy,
                time: selectedForm?.signedAt,
              })}
            </Typography>
          )}
          {selectedForm?.locked && (
            <Typography variant="body1" color="text.secondary">
              {isManualLock
                ? t("LOCK_STATUS_LOCKED", {
                    name: lockedBy,
                    time: selectedForm?.lockedAt,
                  })
                : t("LOCK_STATUS_LOCKED_AUTO", {
                    time: selectedForm?.lockedAt,
                  })}
            </Typography>
          )}
        </>
      )}
    </>
  );
};

export default React.memo(LockStatus);
